import { TextKey, RouteName, FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { hasCurrentEnterpriseServiceId } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { isCurrentEnterpriseActivityReportEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useCommanderSelector } from '@mews-commander/utils';
import { AssistantNavigation } from './AssistantNavigation';
import { useNavigationSearchResult } from './useNavigationSearchResult';

export const useOperationNavigation = (): AssistantNavigation[] => {
    const hasReservableService = useCommanderSelector<boolean>(hasCurrentEnterpriseServiceId);
    const hasActivityReportEnabled = useCommanderSelector<boolean>(isCurrentEnterpriseActivityReportEnabled);

    const newGuestInHouseReportRouteEnabled = useFeatureFlag(FeatureFlag.newGuestInHouseReportRouteEnabled);
    const guestInHouseReportRoute = newGuestInHouseReportRouteEnabled
        ? RouteName.GuestsInHouseReportIndex
        : RouteName.GuestInHouseReportIndex;
    const guestInHouseReportResult = useNavigationSearchResult(guestInHouseReportRoute, TextKey.GuestInHouseReport);

    const eventReportResult = useNavigationSearchResult(RouteName.EventReportIndex, TextKey.EventReport);
    const resourceStatusReportResult = useNavigationSearchResult(
        RouteName.ResourceStatusReportIndex,
        TextKey.ResourceStatusReport
    );
    const activityReportResult = useNavigationSearchResult(RouteName.ActivityReportIndex, TextKey.ActivityReport);
    const productReportResult = useNavigationSearchResult(RouteName.ProductReportIndex, TextKey.ProductReport);

    return ([
        hasReservableService ? guestInHouseReportResult : null,
        eventReportResult,
        resourceStatusReportResult,
        hasActivityReportEnabled ? activityReportResult : null,
        hasReservableService ? productReportResult : null,
    ].filter(Boolean) ?? []) as AssistantNavigation[];
};
